export type UniversalSearchCategory =
    | 'Pages'
    | 'Subsections'
    | 'Employees'
    | 'Projects'
    | 'Clients'
    | string;

export type UniversalSearchResultItem = {
    id: string;
    category: UniversalSearchCategory;
    title: string;
    subtitle?: string;
    route: string;
    navigationState?: Record<string, unknown>;
    queryParams?: Record<string, string | number | boolean>;
    /** CSS icon class from AppMenuItem (e.g. icon-TimeTrack, flaticon-tabs). */
    icon?: string;
    /** Optional custom image path from AppMenuItem. */
    customImage?: string;
    /** Source used for match highlighting (title + subtitle + keywords). */
    matchText?: string;
};

export type UniversalSearchGroup = {
    category: UniversalSearchCategory;
    items: UniversalSearchResultItem[];
};

export type UniversalSearchUiState = 'idle' | 'loading' | 'results' | 'empty' | 'error';

export const UNIVERSAL_SEARCH_MIN_QUERY_LENGTH = 3;
export const UNIVERSAL_SEARCH_DEBOUNCE_MS = 250;
export const UNIVERSAL_SEARCH_MAX_PER_CATEGORY = 5;

export const UNIVERSAL_SEARCH_CATEGORY_ORDER: UniversalSearchCategory[] = [
    'Pages',
    'Subsections',
    'Employees',
    'Projects',
    'Clients',
];

/** Entity categories require the same permissions as their list screens. */
export const UNIVERSAL_SEARCH_CATEGORY_PERMISSIONS: Partial<Record<UniversalSearchCategory, string>> = {
    Projects: 'Pages.Projects',
    Clients: 'Pages.Clients',
};

/** Any of these permissions allows the Employees search category (self and/or others). */
export const UNIVERSAL_SEARCH_EMPLOYEE_PERMISSIONS = [
    'Pages.MyProfile',
    'Pages.Activity.ReamTimeTracking',
    'Pages.Activity.TimeAndAttendence',
    'Pages.Administration.Users',
    'Pages.User.ViewUsers',
    'Pages.Administration.User.CRUD',
] as const;
